"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Router = _interopRequireDefault(require("react-router/lib/Router"));
var _RouterContext = _interopRequireDefault(require("react-router/lib/RouterContext"));
var _reactIntl = require("react-intl");
var _reactHelmetAsync = require("react-helmet-async");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// Shell of the body of the document
// This is called by client-side and server-side
var Shell = /*#__PURE__*/function (_React$Component) {
  function Shell() {
    (0, _classCallCheck2["default"])(this, Shell);
    return _callSuper(this, Shell, arguments);
  }
  (0, _inherits2["default"])(Shell, _React$Component);
  return (0, _createClass2["default"])(Shell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      // Injection point: afterPageMounted
      if (this.props.injectors) {
        this.props.injectors.filter(function (injector) {
          return injector.afterPageMounted;
        }).forEach(function (injector) {
          return injector.afterPageMounted(_this.props.store, _this.props.pageProps);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        store = _this$props.store,
        _this$props$defaultLo = _this$props.defaultLocale,
        defaultLocale = _this$props$defaultLo === void 0 ? 'en' : _this$props$defaultLo,
        helmetContext = _this$props.helmetContext;
      return /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync.HelmetProvider, {
        context: helmetContext
      }, /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
        defaultLocale: defaultLocale,
        initialNow: new Date(),
        key: defaultLocale // https://github.com/yahoo/react-intl/issues/234
        ,
        locale: defaultLocale
      }, process.env.IS_BROWSER ? /*#__PURE__*/_react["default"].createElement(_Router["default"], {
        history: this.props.history
      }, this.props.routes) : /*#__PURE__*/_react["default"].createElement(_RouterContext["default"], this.props.renderProps))));
    }
  }]);
}(_react["default"].Component);
Shell.propTypes = {
  store: _propTypes["default"].object,
  pageProps: _propTypes["default"].object,
  defaultLocale: _propTypes["default"].string,
  helmetContext: _propTypes["default"].object,
  // client side render
  injectors: _propTypes["default"].array,
  history: _propTypes["default"].object,
  routes: _propTypes["default"].object,
  // server side render
  renderProps: _propTypes["default"].object
};
var _default = exports["default"] = Shell;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/render/Shell.js
// module id = 2999
// module chunks = 25